<template>
    <div class="FilterGroup list" v-if="filterList.length">
        <div class="FilterGroup__title">{{title}}</div>
        <div class="FilterGroup__list">
            <component
                    :is="singleSelect ? 'Radio' : 'Checkbox'"
                    class="list__item"
                    v-for="({title, value}, index) of filterList"
                    :label="title"
                    :active="checkActive(value)"
                    :key="index"
                    @select="handleFilterSelect(value)"
            />
        </div>
    </div>
</template>

<script>
import Checkbox from "@/components/elements/Checkbox";
import {mapMutations, mapState} from "vuex";
import Radio from "@/components/elements/Radio";

export default {
    name: "FilterGroup",
    components: {
        Checkbox,
        Radio,
    },
    props: {
        filterType: String,
        title: String,
        filterList: Array,
        singleSelect: Boolean,
    },
    computed: {
        filterGroup() {
            return this.filters[this.filterType];
        },
        ...mapState(['filters'])
    },
    methods: {
        handleFilterSelect(value) {
            if (this.singleSelect) {
                this.setFilters({filters: [value], type: this.filterType})
            } else {
                if (this.checkActive(value)) {
                    const filters = this.filterGroup.filter(filter => filter !== value);
                    this.setFiltersWithType(filters);
                } else {
                    const filters = [...this.filterGroup, value];
                    this.setFiltersWithType(filters);
                }
            }
        },
        checkActive(value) {
            return this.filterGroup.includes(value);
        },
        setFiltersWithType(filters) {
            this.setFilters({filters, type: this.filterType})
        },
        ...mapMutations(['setFilters'])
    }
}
</script>

<style lang="scss">
.FilterGroup {
  white-space: nowrap;

  &__title {
    margin-bottom: 12px;
    color: #999999;
  }

  & + & {
    margin-top: 24px;
  }
}
</style>